import fetch from '@/utils/fetch';

// 获取拍卖订单列表
export function getOrderList(data) {
  return fetch({
    url: '/saas/order/m/s/auction/order/list',
    method: 'post',
    data: data,
  });
}
// 获取拍卖订单详情
export function getOrderDetail(data) {
  return fetch({
    url: '/saas/order/m/s/auction/order/view',
    method: 'post',
    data: data,
  });
}
// 拍卖订单退款
export function refundOrder(data) {
  return fetch({
    url: '/saas/order/m/s/auction/order/refund',
    method: 'post',
    data: data,
  });
}
// 拍卖订单发货
export function shipmentOrder(data) {
  return fetch({
    url: '/saas/order/m/s/auction/order/shipment',
    method: 'post',
    data: data,
  });
}
// 发送催款通知
export function sendPayMessage(data) {
  return fetch({
    url: '/saas/user/m/s/shop/fwh/template/send/press',
    method: 'post',
    data: data,
  });
}
